module.exports = __webpack_public_path__ + "static/media/cert_113.134352e2.jpg";